import React from 'react'
function ProgressSteps({ currentStep = 1, totalSteps = 4 }) {
    return (
        <>
            <div className="step-container">
                <div className="step-line">
                    <div
                        className={`step-line ${currentStep > 1 ? 'active' : ''}`}
                        style={{ width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%` }}
                    />
                </div>
                <div className="steps-wrapper">
                    {[...Array(totalSteps)].map((_, index) => (
                        <div
                            key={index}
                            className={`step-dot ${index < currentStep ? 'active' : ''}`}
                        />
                    ))}
                </div>
            </div>
        </>
    )
}

export default ProgressSteps